import React from 'react';
import dayjs from 'dayjs';
import Select from "react-select";
import MobileHeaderSarang from '../../../components/mobile-header/mobile-header-sarang';
import FormSearchWrapperSarang from '../../../components/form-search-wrapper-sarang/form-search-wrapper-sarang';
import DataTablePagination from '../../../components/datatable-sarang/datatable-pagination';
import headCellsListCuisineOrder from '../head-cell-list-cuisine-order';
import { optionsCuisineOrderStatus, optionsReceiptTime } from '../../../common/constant';
import tickIcon from "../../../assets/icon/tick.png";
import cancelIcon from "../../../assets/icon/cancel.png";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";

const CuisineOrderMobileList = ({
    headCells,
    handleSortChange,
    setOrder,
    setOrderBy,
    configLocal,
    getListCuisineOrderManagement,
    searchData,
    sumaryCuisine,
    data,
    totalItemCount,
    rowsPerPage,
    page,
    handleChangePage,
    isTabletOrMobile,
    openSearch,
    setOpenSearch,
    openAddDialog,
    renderFormSearch,
    setOpenChangeStatusDialog,
    openConfirmDialog,
    setOpenChangeConfirmDialog,
    setOpenDeleteDialog,
    openEditDialog
}) => {
    return (
        <>
            <div className="accrodion-regular">
                <MobileHeaderSarang
                    headCell={headCellsListCuisineOrder}
                    handleSortChange={handleSortChange}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                    configLocal={configLocal}
                    getList={getListCuisineOrderManagement}
                    searchData={searchData}
                />
                <div id="accordion">
                    <div className="card">
                        <div className="d-flex align-items-center">
                            <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                                data-toggle="collapse" aria-expanded="false" >
                                <div className="d-flex w-100">
                                    <div>Tổng SL đơn: <b>{sumaryCuisine?.sumaryCuisineOrder}</b> - <span className="text-primary">Trưa: <b>{sumaryCuisine?.sumaryLunchOrder}</b></span> - <span className="text-danger">Chiều: <b>{sumaryCuisine?.sumaryDinnerOrder}</b></span></div>
                                    <hr />
                                    <div>Tổng suất ăn: <b>{sumaryCuisine?.sumaryCuisineQuatity}</b> - <span className="text-primary">Trưa: <b>{sumaryCuisine?.sumaryLunch}</b></span> - <span className="text-danger">Chiều: <b>{sumaryCuisine?.sumaryDinner}</b></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        data.length > 0 ?
                            data.map((item, index) => (
                                <div className="card" key={index}>
                                    <div className="d-flex align-items-center" id={`heading-${item.id}`}>
                                        <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                                            data-toggle="collapse" data-target={`#collapse-${item.id}`} aria-expanded="false" aria-controls={`collapse-${item.id}`}>
                                            <div className="d-flex w-100 justify-content-between">
                                                <h5 className={item.receiptTime === 2 ? "mb-1 text-primary" : "mb-1 text-danger"}>{item.orderCode}</h5>
                                                <small className={item.receiptTime === 2 ? "d-flex align-items-center text-primary" : "d-flex align-items-center text-danger"} >
                                                    {optionsReceiptTime.find(option => option.value === item.receiptTime)?.label}/
                                                    {dayjs(item.orderDate).format("DD/MM/YYYY")}
                                                </small>
                                            </div>
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className='mt-0'><b>Ace đặt:</b></div>
                                                    <span>{item.herdsManOrderName}</span>
                                                    <div className='mt-2'><b>Điện thoại:</b></div>
                                                    {
                                                        item.herdsManOrderPhoneNumber ?
                                                            <span>
                                                                <a href={`tel:${item.herdsManOrderPhoneNumber}`}>{item.herdsManOrderPhoneNumber}</a>
                                                                <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table phone ml-2" data-toggle="tooltip" data-placement="top"
                                                                    title="Gọi"
                                                                    onClick={() => {
                                                                        window.location.href = `tel:${item.herdsManOrderPhoneNumber}`;
                                                                    }}
                                                                >
                                                                    <i className="fas fa-phone"></i>
                                                                </button>
                                                            </span> :
                                                            <br />
                                                    }
                                                    <div className='mt-2'><b>Số lượng: </b> {item.quatity}</div>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='mt-0'>
                                                        <b>Tình trạng: </b>
                                                        <span>
                                                            {
                                                                item.orderStatus >= 20 ?
                                                                    (
                                                                        <img title="Đã xác nhận" src={tickIcon} alt="Tick" />
                                                                    ) : (
                                                                        <img title="Chưa xác nhận" style={{ cursor: 'pointer' }}
                                                                            src={cancelIcon}
                                                                            alt="Cancel" onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                e.preventDefault();
                                                                                if (item.allowConfirm) {
                                                                                    setOpenChangeConfirmDialog(true);
                                                                                    openConfirmDialog(item);
                                                                                }
                                                                                else {
                                                                                    ShowNotification("Ae/Ce không có quyền xác nhận", NotificationMessageType.Warning);
                                                                                }
                                                                            }}
                                                                        />
                                                                    )}
                                                        </span>
                                                    </div>
                                                    <div className='mt-2'>
                                                        <b>Trạng thái: </b>
                                                        {
                                                            (!item.allowChangeStatus) ? <span>{item.orderStatusName}</span> :
                                                                <span>
                                                                    <Select
                                                                        value={item?.orderStatus ? { label: item.orderStatusName, value: item.orderStatus } : null}
                                                                        placeholder="Chọn Trạng thái"
                                                                        onChange={(data) => {
                                                                            setOpenChangeStatusDialog(true);
                                                                            openConfirmDialog({ ...item, orderStatusChange: data.value, orderStatusNameChange: data.label });
                                                                        }}
                                                                        options={optionsCuisineOrderStatus.filter(x => ((x.value === 30 || x.value >= 50) && x.value !== item.orderStatus) && x.value >= item?.orderStatus)}
                                                                        noOptionsMessage={() => "Không tồn tại"}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                </span>
                                                        }
                                                    </div>
                                                    <div className='mt-0'><b>Hình thức giao:</b></div>
                                                    <span>{item.deliveryType === 0 ? "Giao nhận" : "Tự lấy"}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <i className="fas fa-angle-down p-2"></i>
                                    </div>
                                    <div id={`collapse-${item.id}`} className="collapse" aria-labelledby={`heading-${item.id}`} data-parent="#accordion">
                                        <div className="card-body">
                                            <div className='row'>
                                                <div className='col-6'>
                                                    <div className='mt-0'><b>Địa chỉ:</b></div>
                                                    <span>{item.address}</span>
                                                </div>
                                                <div className='col-6'>
                                                    <div className='mt-0'><b>Ace Xác nhận:</b></div>
                                                    <span>{item.herdsManConfirmName}</span>
                                                    <div className='mt-0'><b>Ace giao:</b></div>
                                                    <span>
                                                        {
                                                            item.herdsmanDeliveryName ?
                                                                <span>{item.herdsmanDeliveryName} &nbsp;
                                                                    {
                                                                        item.herdsmanDeliveryPhone ?
                                                                            <>
                                                                                (<a href={`tel:${item.herdsmanDeliveryPhone}`}>{item.herdsmanDeliveryPhone}</a>)
                                                                                <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table phone ml-2" data-toggle="tooltip" data-placement="top"
                                                                                    title="Gọi"
                                                                                    onClick={() => {
                                                                                        window.location.href = `tel:${item.herdsmanDeliveryPhone}`;
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-phone"></i>
                                                                                </button>
                                                                            </> :
                                                                            <></>
                                                                    }
                                                                </span> :
                                                                <span style={{ width: "100%", display: "inline-block" }}>
                                                                    --
                                                                </span>
                                                        }
                                                    </span>
                                                </div>
                                            </div>

                                            <div className='mt-0'><b>Ghi chú:</b></div>
                                            <span>{item.description}</span>
                                            {item.allowEdit &&
                                                <div className='d-flex'>
                                                    <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table edit" data-toggle="tooltip" data-placement="top"
                                                        title="Sửa"
                                                        onClick={() => { openEditDialog(item) }}
                                                    >
                                                        <i className="far fa-edit"></i>
                                                    </button>
                                                    <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table delete" data-toggle="tooltip" data-placement="top"
                                                        title="Xóa"
                                                        onClick={() => {
                                                            setOpenDeleteDialog(true);
                                                            openConfirmDialog(item);
                                                        }}
                                                    >
                                                        <i className="far fa-trash-alt"></i>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )) : <div className="card">Chưa có dữ liệu</div>
                    }
                </div>
                {
                    totalItemCount > 0 ?
                        <DataTablePagination
                            totalItemCount={totalItemCount}
                            rowsPerPage={rowsPerPage}
                            pageIndex={page + 1}
                            handleChangePage={handleChangePage}
                        /> :
                        <></>
                }
            </div>
            <FormSearchWrapperSarang
                isTabletOrMobile={isTabletOrMobile} openSearch={openSearch} setOpenSearch={setOpenSearch} openAddDialog={openAddDialog}
            >
                {renderFormSearch()}
            </FormSearchWrapperSarang>
        </>
    );
};

export default CuisineOrderMobileList;
